import { render } from "./Crowd.vue?vue&type=template&id=11421c6a&scoped=true"
import script from "./Crowd.vue?vue&type=script&lang=js"
export * from "./Crowd.vue?vue&type=script&lang=js"

import "./Crowd.vue?vue&type=style&index=0&id=11421c6a&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11421c6a"]])

export default __exports__